import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicPageBuilderQRCodeComponent } from './dynamic-page-builder-qrcode.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { PageBuilderQRCodeDesignComponent } from './qrcode-design/page-builder-qrcode-design.component';

@NgModule({
    declarations: [
        PageBuilderQRCodeDesignComponent, DynamicPageBuilderQRCodeComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    entryComponents: [
        DynamicPageBuilderQRCodeComponent
    ]
})
export class PageBuilderQRCodeModule {}